export const MAX_NOTICE_ATTACHMENTS = 100;
export const NOTICE_ATTACHMENT_LIMIT_MESSAGE =
  `공지사항에는 사진·영상을 최대 ${MAX_NOTICE_ATTACHMENTS}개까지 첨부할 수 있습니다.`;

export function mergeNoticeAttachments<T extends { ImgID: number }>(
  current: T[],
  incoming: T[]
): T[] {
  const seen = new Set<number>();
  return [...current, ...incoming].filter((image) => {
    if (seen.has(image.ImgID)) return false;
    seen.add(image.ImgID);
    return true;
  });
}
